import React, { useState, useEffect } from "react";
import logo from "../../assets/images/logo_2x.png";
import like from "../../assets/images/like.svg";
import { NavLink, useHistory, useParams } from "react-router-dom";
import Api from "../../Api";
import { toast } from "react-toastify";

export const AcceptingInvitation = () => {
  const params: {
    uid?: string;
    temppin?: string;
    GroupNames?: string;
  } = useParams();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(true);

  const acceptVendorInvite = (uid: string, pin: string) => {
    Api.vendorsUpdateInvite({ uid, pin, invitationStatus: "accepted" })
      .then(res => { 
        setIsLoading(false);
        if (res) {
          setSuccess(true);
        } else {
          setError(true);
        }
      })
      .catch(err => {
        toast.error("Action already taken!", {
          onClose:() =>{
            history.push("/login");
          }
        });
        setError(true);
        console.log(err);
      });
  };

  const acceptOwnerInvite = (uid: string, pin: string) => {
    Api.ownersUpdateInvite({ uid, pin, invitationStatus: "accepted" })
      .then(res => {
        setIsLoading(false);
        if (res) {
          setSuccess(true);
        } else {
          setError(true);
        }
        console.log(res);
      })
      .catch(err => {
        setError(true); 
        setIsLoading(false);
        console.log(err);
        toast.error("Action already taken!", {
          onClose:() =>{
            history.push("/login");
          }
        });
      });
  };

  useEffect(() => {
    if (isFirstTime) {
      setIsFirstTime(false);
      let uid = params.uid ? params.uid : "";
      let pin = params.temppin ? params.temppin : "";
      const GroupNames = params.GroupNames ? params.GroupNames : "";
      setIsLoading(true);
      if (GroupNames.includes("Festival Vendors") === true) {
        acceptVendorInvite(uid, pin);
      }

      if (GroupNames.includes("Festival Owners") === true) {
        acceptOwnerInvite(uid, pin);
      }
    }
  }, [success, isLoading, error, isFirstTime]);

  const handleGettingStarted = () => {
    history.push("/login");
  };

  return (   
    <div>
      <div className="non--login">
      {isLoading == false &&  success == true  ? (
        <div className="login-form alert-messages">
          <div className="logo_img">
            <img src={logo} alt="F" />
            <h1>
              <span>FEST</span>FRWRD
            </h1>
          </div>

          <div className="login-form--inner text-center">
            <img src={like} alt="" />
            <h2>Thank you for accepting our invitation!</h2>
            <p className="text-center">
              <b>We are delighted to have you on board.</b>
            </p>
            <p className="text-center">
              You may access the FestFrwrd Web/Mobile Applications using the
              appropriate link below. Do keep your access credentials handy.
            </p>
              <div className="text-center">
                <button
                  className="btn-submit"
                  onClick={handleGettingStarted}
                >
                Get Started                
                </button>
              </div>
          </div>
        </div>  ): null}
      </div>
      <div className="footer">Copyright. All rights reserved 2019</div>
    </div>
  );
};
